function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_2140_1345)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0998 9.30029L11.4338 10.2029C11.839 11.2978 12.7022 12.161 13.7971 12.5661L14.6997 12.9001L13.7971 13.2341C12.7022 13.6393 11.839 14.5025 11.4338 15.5974L11.0998 16.5L10.7658 15.5974C10.3607 14.5025 9.49747 13.6393 8.40259 13.2341L7.5 12.9001L8.40259 12.5661C9.49747 12.161 10.3607 11.2978 10.7658 10.2029L11.0998 9.30029Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8738 7.5L14.9922 7.81992C15.1948 8.36736 15.6264 8.79898 16.1738 9.00155L16.4938 9.11993L16.1738 9.23831C15.6264 9.44088 15.1948 9.8725 14.9922 10.4199L14.8738 10.7399L14.7555 10.4199C14.5529 9.8725 14.1213 9.44088 13.5738 9.23831L13.2539 9.11993L13.5738 9.00155C14.1213 8.79898 14.5529 8.36736 14.7555 7.81992L14.8738 7.5Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2140_1345",
  x1: 0,
  y1: 12,
  x2: 24,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#54A5F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3981C3"
})));

function SvgCircularStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularStar);
export default __webpack_public_path__ + "static/media/CircularStar.288cf6a8.svg";
export { ForwardRef as ReactComponent };